import type { ReactNode } from "react";

type OverviewSectionBadgeProps = {
  children: ReactNode;
};

export function OverviewSectionBadge({ children }: OverviewSectionBadgeProps) {
  return <span className="app-section-eyebrow">{children}</span>;
}
